import { styled } from "@mui/system";
import { Box } from "@mui/material";
import { Button } from "@/app/components/UI";
import { FILE_TYPE_ENUM } from "@/app/components/UI/VideoPlayer";
import CheckIcon from "@mui/icons-material/Check";

const ToggleContainer = styled(Box)(() => ({
  display: "flex",
  background: "rgba(255, 255, 255, 0.08)",
  borderRadius: "100px",
  padding: "4px",
  gap: "4px",
  width: "124px"
}));

const ToggleButton = styled(Button)<{ selected?: boolean }>(({ selected }) => ({
  flex: 1,
  borderRadius: "100px",
  minWidth: "unset",
  height: "28px",
  fontSize: "14px",
  lineHeight: "20px",
  padding: "4px 8px",
  color: selected ? "#fff" : "rgba(255, 255, 255, 0.6)"
}));

interface ShareFormatToggleProps {
  value: FILE_TYPE_ENUM;
  onChange: (format: FILE_TYPE_ENUM) => void;
}

export default function FileTypeChoose({ value, onChange }: ShareFormatToggleProps) {
  return (
    <ToggleContainer>
      <ToggleButton
        selected={value === FILE_TYPE_ENUM.video}
        onClick={() => onChange(FILE_TYPE_ENUM.video)}
        startIcon={value === FILE_TYPE_ENUM.video ? <CheckIcon /> : null}
      >
        MP4
      </ToggleButton>
      <ToggleButton
        selected={value === FILE_TYPE_ENUM.image}
        onClick={() => onChange(FILE_TYPE_ENUM.image)}
        startIcon={value === FILE_TYPE_ENUM.image ? <CheckIcon /> : null}
      >
        GIF
      </ToggleButton>
    </ToggleContainer>
  );
}
